import { render, staticRenderFns } from "./Socio-pagamento.vue?vue&type=template&id=1a2acfa3&"
import script from "./Socio-pagamento.vue?vue&type=script&lang=js&"
export * from "./Socio-pagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Socio-pagamento.vue"
export default component.exports